angular.module('tgaAdmin').controller('HubAnalyticsXapiController', [
  '$scope',
  '$state',
  '$timeout',
  'gameService',
  'playerService',
  'statsService',
  'reportService',
  '$filter',
  '$uibModal',
  'userService',
  'ngIntroService',
  'instructorService',
  'tzService',
  '$log',
  'settingsService',
  'xapiService',
  function (
    $scope,
    $state,
    $timeout,
    gameService,
    playerService,
    statsService,
    reportService,
    $filter,
    $uibModal,
    userService,
    ngIntroService,
    instructorService,
    tzService,
    $log,
    settingsService,
    xapiService,
  ) {
    $scope.showBack = false;

    $scope.data = {
      alerts: [],
      filedate: moment().format('YYYY-MM-DD HH-mm-ss'),
      game_id: parseInt($state.params.game_id, 10) || null,
      separator: ',',
      decimalSeparator: '.',
      countupOptions: {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: ':',
      },
      datePickerOptions: settingsService.getDatePickerOptions(
        {},
        {
          'apply.daterangepicker': function (ev, picker) {
            $scope.viewmodel.range = picker.chosenLabel;

            if (
              !$scope.viewmodel.dateRange.startDate.isSame($scope.viewmodel.oldRange.startDate, 'day')
              || !$scope.viewmodel.dateRange.endDate.isSame($scope.viewmodel.oldRange.endDate, 'day')
            ) {
              $scope.viewmodel.dateRange = $scope.viewmodel.oldRange = {
                startDate: picker.startDate,
                endDate: picker.endDate,
              };
              $scope.actions.getGame();
            }
          },
          'outsideClick.daterangepicker': function () {
            $scope.viewmodel.dateRange = {
              startDate: $scope.viewmodel.oldRange.startDate,
              endDate: $scope.viewmodel.oldRange.endDate,
            };
          },
        },
      ),
      chartOptions: {
        series: [
          {
            name: 'Sessions',
            data: [],
          },
          {
            name: 'Players',
            data: [],
          },
        ],
        chart: {
          height: 250,
          type: 'line',
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
          animations: {
            enabled: false,
          },
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetY: 15,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'straight',
          width: 4,
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [],
          labels: {
            rotate: 0,
          },
        },
        yaxis: [
          {
            seriesName: 'Sessions',
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#008FFB',
            },
            labels: {
              style: {
                colors: '#008FFB',
              },
            },
            title: {
              text: 'Sessions',
              style: {
                color: '#008FFB',
              },
            },
          },
          {
            seriesName: 'Players',
            opposite: true,
            axisTicks: {
              show: true,
            },
            axisBorder: {
              show: true,
              color: '#00E396',
            },
            labels: {
              style: {
                colors: '#00E396',
              },
            },
            title: {
              text: 'Players',
              style: {
                color: '#00E396',
              },
            },
          },
        ],
      },
    };

    $scope.viewmodel = {
      showChart: false,
      game: {},
      players: [],
      statements: [],
      range: $state.params.range || 'Last 30 Days',
      oldRange: {
        startDate: moment().subtract(29, 'days').startOf('day'),
        endDate: moment().endOf('day'),
      },
      dateRange: {
        startDate: $state.params.dateRange.startDate || moment().subtract(29, 'days').startOf('day'),
        endDate: $state.params.dateRange.endDate || moment().endOf('day'),
      },
    };

    $scope.initialize = function () {
      $scope.actions.getGame();
    };

    $scope.actions = {
      toggleChart() {
        $scope.viewmodel.showChart = !$scope.viewmodel.showChart;
      },
      getGame() {
        $scope.actions.loadChart();
        $scope.loadingGame = true;

        gameService
          .getGame($scope.data.game_id)
          .then((game) => {
            $scope.viewmodel.game = game;
            $scope.viewmodel.statements = [];
            $scope.actions.loadStatements({ limit: 50 });
            $scope.loadingGame = false;
          })
          .catch(() => {
            $state.go('v1.games');
          });
      },
      loadChart() {
        $scope.loadingChart = true;

        statsService
          .getOverviewChart(
            $scope.data.game_id,
            $scope.viewmodel.dateRange.startDate.toISOString(true),
            $scope.viewmodel.dateRange.endDate.toISOString(true),
          )
          .then((response) => {
            $scope.data.chartOptions.series = [
              {
                name: 'Sessions',
                data: response.sessions,
              },
              {
                name: 'Players',
                data: response.players,
              },
            ];

            $scope.data.chartOptions.xaxis.categories = response.xaxis;
          });
      },
      loadStatements(params) {
        $scope.loadingUsers = true;
        xapiService
          .getStatements($scope.viewmodel.game.xapi_endpoint, $scope.viewmodel.game.xapi_auth, params)
          .then((data) => {
            $scope.viewmodel.statements = $scope.viewmodel.statements.concat(data.statements);

            if (data.more && data.more !== '') {
              const paramsObject = Object.fromEntries(new URLSearchParams(data.more.split('?').slice(1).join()));
              $scope.actions.loadStatements(paramsObject);
            } else {
              $scope.actions.processStatements();
            }
          });
      },
      processStatements() {
        $log.debug('statements', $scope.viewmodel.statements);
        const players = [];
        const levels = {};
        $scope.viewmodel.statements.forEach((s) => {
          if (s.verb.id === 'http://adlnet.gov/expapi/verbs/entered') {
            levels[s.object.id] = s.object.definition.name['en-US'].replace(/\D/g, '');
          }
        });
        $scope.viewmodel.statements
          .filter(
            (s) => s?.context?.extensions && s.context.extensions[`${$scope.viewmodel.game.xapi_activity_id}/sessionID`],
          )
          .forEach((s) => {
            players[s.actor.name] = players[s.actor.name] || {
              username: s.actor.name,
              total_sessions: 0,
              unique_sessions: new Set(),
              sessions: {},
              total_complete: 0,
              time: 0,
              level: null,
              total_items: 0,
              total_clues: 0,
            };

            const player = players[s.actor.name];
            const sessionId = s.context.extensions[`${$scope.viewmodel.game.xapi_activity_id}/sessionID`];
            player.sessions[sessionId] = player.sessions[sessionId] || {
              date: s.timestamp,
              time: null,
              level: null,
              levels: {},
              items: new Set(),
              clues: new Set(),
              total_items: 0,
              total_clues: 0,
              complete: false,
            };

            player.unique_sessions.add(sessionId);
            player.total_sessions = player.unique_sessions.size;

            // Entered level
            if (s.verb.id === 'http://adlnet.gov/expapi/verbs/entered') {
              const level = parseInt(s.object.definition.name['en-US'].replace(/\D/g, ''), 10);
              player.level = player.level < level ? level : player.level;
              const levelId = s.object.id;
              player.sessions[sessionId].levels[levelId] = player.sessions[sessionId].levels[levelId] || {
                name: levels[levelId],
                time: null,
                items: new Set(),
                clues: new Set(),
              };
              player.sessions[sessionId].level = player.sessions[sessionId].level < level ? level : player.sessions[sessionId].level;
            }

            // Exited level
            if (s.verb.id === 'http://adlnet.gov/expapi/verbs/exited') {
              const levelId = s.object.id;
              player.sessions[sessionId].levels[levelId] = player.sessions[sessionId].levels[levelId] || {
                name: levels[levelId],
                time: null,
                items: new Set(),
                clues: new Set(),
              };
              player.sessions[sessionId].levels[levelId].time = moment.duration(s?.result?.duration);
            }

            // Item clicked
            if (s.verb.id === 'http://adlnet.gov/expapi/verbs/reviewed') {
              const item = s.object.definition.name['en-US'];
              const levelId = s.context.contextActivities.parent[0].id;
              player.sessions[sessionId].items.add(item);
              // Sum up the unique items clicked per session
              player.total_items = Object.values(player.sessions)
                .map((x) => x.items.size)
                .reduce((a, b) => a + b, 0);
              player.sessions[sessionId].levels[levelId] = player.sessions[sessionId].levels[levelId] || {
                name: levels[levelId],
                time: null,
                items: new Set(),
                clues: new Set(),
              };
              player.sessions[sessionId].levels[levelId].items.add(item);
              player.sessions[sessionId].total_items = Object.values(player.sessions[sessionId].levels)
                .map((x) => x.items.size)
                .reduce((a, b) => a + b, 0);
            }

            // Clue used
            if (s.verb.id === 'http://adlnet.gov/expapi/verbs/used') {
              const clue = s.object.definition.name['en-US'];
              const levelId = s.context.contextActivities.parent[0].id;
              player.sessions[sessionId].clues.add(clue);
              // Sum up the unique clues per session
              player.total_clues = Object.values(player.sessions)
                .map((x) => x.clues.size)
                .reduce((a, b) => a + b, 0);
              player.sessions[sessionId].levels[levelId] = player.sessions[sessionId].levels[levelId] || {
                name: levels[levelId],
                time: null,
                items: new Set(),
                clues: new Set(),
              };
              player.sessions[sessionId].levels[levelId].clues.add(clue);
              player.sessions[sessionId].total_clues = Object.values(player.sessions[sessionId].levels)
                .map((x) => x.clues.size)
                .reduce((a, b) => a + b, 0);
            }

            if (s.verb.id === 'http://adlnet.gov/expapi/verbs/completed') {
              player.total_complete++;
              if (s?.result?.duration) {
                player.time += moment.duration(s?.result?.duration) || 0;
                player.sessions[sessionId].complete = true;
                player.sessions[sessionId].time = moment.duration(s?.result?.duration);
              }
            }
          });

        const playersArr = Object.values(players);
        const totalLevels = playersArr.map((p) => p.level).reduce((a, b) => a + b, 0);
        $scope.viewmodel.avg_level = totalLevels / playersArr.length;
        $scope.viewmodel.avg_items = playersArr.map((p) => p.total_items).reduce((a, b) => a + b, 0) / totalLevels;
        $scope.viewmodel.avg_clues = playersArr.map((p) => p.total_clues).reduce((a, b) => a + b, 0) / totalLevels;

        $scope.actions.loadUsers(players);
      },
      loadUsers(players) {
        const startDate = $scope.viewmodel.dateRange.startDate.toISOString(true);
        const endDate = $scope.viewmodel.dateRange.endDate.toISOString(true);

        $scope.loadingUsers = true;

        statsService.getSessionStats($scope.data.game_id, startDate, endDate).then((stats) => {
          const avg_time = $filter('formatDuration')(stats.average_time).split(':');
          $scope.viewmodel.average_time = parseFloat(`${avg_time[1]}.${avg_time[2]}`);
          $scope.viewmodel.total_sessions = stats.total_sessions;
          $scope.viewmodel.completed_sessions = stats.completed_sessions;
          $scope.viewmodel.average_score = stats.average_score || 0;
          $scope.viewmodel.average_accuracy = stats.average_accuracy * 100 || 0;
          $scope.viewmodel.total_players = stats.total_players || 0;

          if (stats.first_date) {
            $scope.data.datePickerOptions.ranges['All Time'] = [moment(stats.first_date).startOf('month'), moment()];
          }
        });

        playerService.getNewPlayers($scope.data.game_id, startDate, endDate).then((total) => {
          $scope.viewmodel.new_players = total;
        });

        playerService
          .getPlayers({ game_id: $scope.data.game_id, start_date: startDate, end_date: endDate })
          .then((response) => {
            response.forEach((p) => {
              players[p.username] = {
                ...p,
                ...players[p.username],
              };
            });
            $scope.viewmodel.players = Object.values(players);
            $log.debug('$scope.viewmodel.players', $scope.viewmodel.players);
            $scope.loadingUsers = false;
            $scope.loadingChart = false;
          });
      },
      playerDetails(player) {
        $uibModal
          .open({
            animation: true,
            templateUrl: 'templates/partials/hub/analytics/activity/xapi-player.html',
            controller: 'XapiPlayerController',
            size: 'lg',
            backdrop: true,
            resolve: {
              extra() {
                return {
                  player,
                  statements: $scope.viewmodel.statements.filter((s) => s.actor.name === player.username),
                  game: $scope.viewmodel.game,
                  game_id: $scope.data.game_id,
                  required_fields: $scope.viewmodel.required_fields,
                  startDate: $scope.viewmodel.dateRange.startDate,
                  endDate: $scope.viewmodel.dateRange.endDate,
                };
              },
            },
          })
          .result.catch(angular.noop);
      },
      exportStats() {
        if (!$scope.viewmodel.players.length) {
          return false;
        }

        $scope.exporting = true;

        const workbook = new ExcelJS.Workbook();
        workbook.creator = 'The Training Arcade';

        // Overview
        let worksheet = workbook.addWorksheet('Overview');

        // add column headers
        let header = [
          { header: 'Player', key: 'player', width: 12 },
          { header: 'User ID', key: 'username', width: 12 },
          { header: 'Total Sessions', key: 'total_sessions', width: 12 },
          { header: 'Completed Sessions', key: 'total_complete', width: 12 },
          { header: 'Total Time', key: 'time', width: 12 },
          { header: 'Level', key: 'level', width: 12 },
          { header: 'Items Clicked', key: 'items', width: 12 },
          { header: 'Clues Used', key: 'clues', width: 12 },
        ];

        worksheet.columns = header;

        for (let j = 0; j < $scope.viewmodel.players.length; j++) {
          const total_time = $filter('formatDuration')($scope.viewmodel.players[j].time).split(':');

          const rowData = {
            player: $scope.viewmodel.players[j].full_name || $scope.viewmodel.players[j].display_name,
            username: $scope.viewmodel.players[j].username,
            total_sessions: $scope.viewmodel.players[j].total_sessions,
            total_complete: $scope.viewmodel.players[j].total_complete,
            time: {
              formula: `TIME(${total_time[0]},${total_time[1]},${total_time[2]}) + INT(${total_time[0]}/ 24)`,
            },
            level: $scope.viewmodel.players[j].level,
            items: $scope.viewmodel.players[j].total_items,
            clues: $scope.viewmodel.players[j].total_clues,
          };

          worksheet.addRow(rowData);
        }

        worksheet.getColumn(5).numFmt = '[h]:mm:ss';
        worksheet.getColumn(6).numFmt = null;

        worksheet.getRow(1).font = { bold: true };

        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        worksheet.properties.outlineProperties = {
          summaryBelow: false,
          summaryRight: false,
        };

        // Sessions
        worksheet = workbook.addWorksheet('Sessions');

        // add column headers
        header = [
          { header: 'Player', key: 'player', width: 12 },
          { header: 'User ID', key: 'username', width: 12 },
          { header: 'Session #', key: 'session_num', width: 12 },
          { header: 'Date', key: 'session_date', width: 12 },
          { header: 'Duration', key: 'session_duration', width: 12 },
          { header: 'Duration (s)', key: 'session_seconds', width: 12 },
          { header: 'Final Level', key: 'final_level', width: 12 },
          { header: 'Total Items Clicked', key: 'total_items', width: 12 },
          { header: 'Total Clues Used', key: 'total_clues', width: 12 },
          { header: 'Level', key: 'level', width: 12 },
          { header: 'Level Duration', key: 'level_duration', width: 12 },
          { header: 'Items Clicked', key: 'level_items', width: 12 },
          { header: 'Clues Used', key: 'level_clues', width: 12 },
        ];

        worksheet.columns = header;

        let row = 2;
        const collapseRows = [];

        $scope.viewmodel.players.forEach((player) => {
          const sessions = Object.values(player.sessions);
          sessions.forEach((session, session_num) => {
            const session_time = $filter('formatDuration')(session.time).split(':');

            const rowData = {
              player: player.full_name || player.display_name,
              username: player.username,
              session_num: `Session ${session_num + 1}`,
              session_date: tzService.parseFormatUserDate(session.date, 'YYYY-MM-DD HH:mm:ss'),
              session_duration: {
                formula: `TIME(${session_time[0]},${session_time[1]},${session_time[2]}) + INT(${session_time[0]}/ 24)`,
              },
              session_seconds: session.time / 1000.0, // milliseconds -> seconds
              final_level: session.level,
              total_items: session.total_items,
              total_clues: session.total_clues,
            };

            worksheet.addRow(rowData);
            row++;

            session.levels = session.levels ? Object.values(session.levels) : [];
            if (session.levels.length) {
              collapseRows.push({ start: row, end: row + session.levels.length });
            }

            session.levels.forEach((level) => {
              const level_time = $filter('formatDuration')(level.time).split(':');

              worksheet.addRow({
                level: level.name,
                level_duration: {
                  formula: `TIME(${level_time[0]},${level_time[1]},${level_time[2]}) + INT(${level_time[0]}/ 24)`,
                },
                level_items: level.items.join(', '),
                level_clues: level.clues.join(', '),
              });

              row++;
            });
          });
        });

        collapseRows.forEach((collapseRow) => {
          for (let i = collapseRow.start; i < collapseRow.end; i++) {
            worksheet.getRow(i).outlineLevel = 1;
          }
        });

        worksheet.getColumn(5).numFmt = '[h]:mm:ss';
        worksheet.getColumn(6).numFmt = null;
        worksheet.getColumn(11).numFmt = '[h]:mm:ss';

        worksheet.getRow(1).font = { bold: true };

        worksheet.views = [{ state: 'frozen', ySplit: 1 }];

        worksheet.properties.outlineProperties = {
          summaryBelow: false,
          summaryRight: false,
        };

        // save workbook to disk
        workbook.xlsx
          .writeBuffer({ base64: true })
          .then((xls64) => {
            // build anchor tag and attach file (works in chrome)
            // eslint-disable-next-line angular/document-service
            const a = document.createElement('a');
            const data = new Blob([xls64], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = URL.createObjectURL(data);
            a.href = url;
            a.download = reportService.generateReportFilename(
              `${$scope.viewmodel.game.name} Stats`,
              $scope.viewmodel.dateRange.startDate,
              $scope.viewmodel.dateRange.endDate,
              'xlsx',
            );
            // eslint-disable-next-line angular/document-service
            document.body.appendChild(a);
            a.click();
            // eslint-disable-next-line angular/timeout-service
            setTimeout(() => {
              // eslint-disable-next-line angular/document-service
              document.body.removeChild(a);
              // eslint-disable-next-line angular/window-service
              window.URL.revokeObjectURL(url);
            }, 0);
          })
          .catch((error) => {
            $log.log(error.message);
          });

        $scope.exporting = false;
        return true;
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
    };

    $scope.$on('$destroy', () => {
      ngIntroService.clear();
    });

    $scope.initialize();
  },
]);
